import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardHeader, CardTitle, CardDescription } from '../../components/ui/card';
import Button from '../../components/ui/button';
import { Code, Server, Shield } from 'lucide-react';

const APIPage = () => {
  const apiEndpoints = [
    {
      method: 'GET',
      path: '/api/llm/compatibility',
      description: 'Check website compatibility with LLMs',
      category: 'Validation'
    },
    {
      method: 'POST',
      path: '/api/security/scan',
      description: 'Perform comprehensive security assessment',
      category: 'Security'
    },
    {
      method: 'GET',
      path: '/api/insights/report',
      description: 'Retrieve detailed LLM and security insights',
      category: 'Reporting'
    }
  ];

  return (
    <div className="min-h-screen bg-background py-16">
      <div className="container mx-auto px-4">
        {/* Hero Section */}
        <section className="text-center mb-16">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">
            LLM Checks <span className="text-primary">API</span>
          </h1>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            Powerful API for integrating advanced LLM validation and security checks into your workflow
          </p>
        </section>

        {/* API Endpoints */}
        <section className="mb-16">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold mb-4">API Endpoints</h2>
            <p className="text-muted-foreground max-w-2xl mx-auto">
              Comprehensive set of endpoints to validate, analyze, and secure your AI models
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {apiEndpoints.map((endpoint, index) => (
              <Card key={index} className="border-0 shadow-lg hover:shadow-xl transition-all duration-300 hover:border-primary/20 h-full">
                <CardHeader>
                  <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mb-4">
                    {endpoint.category === 'Validation' && <Code className="w-6 h-6 text-primary" />}
                    {endpoint.category === 'Security' && <Shield className="w-6 h-6 text-red-500" />}
                    {endpoint.category === 'Reporting' && <Server className="w-6 h-6 text-blue-500" />}
                  </div>
                  <CardTitle>{endpoint.method} {endpoint.path}</CardTitle>
                  <CardDescription>{endpoint.description}</CardDescription>
                </CardHeader>
              </Card>
            ))}
          </div>
        </section>

        {/* Documentation CTA */}
        <section className="text-center">
          <h2 className="text-3xl font-bold mb-6">Ready to Integrate?</h2>
          <p className="text-muted-foreground max-w-2xl mx-auto mb-8">
            Explore our comprehensive documentation to get started with LLM Checks API
          </p>
          <Link to="/product/documentation">
            <Button size="lg">
              View Full Documentation
            </Button>
          </Link>
        </section>
      </div>
    </div>
  );
};

export default APIPage;
